import React, { useState, useEffect } from 'react'
import { createSelector } from 'reselect'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { Box, Container, Grid, CircularProgress } from '@material-ui/core'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

//COMPONENTS
import Search from '../../components/Search/Search'
import ExperienceCard from '../../components/ExperienceCard/ExperienceCard'
import Footer from '../../components/Footer/Footer'

import WhiteLogo from '../../assets/img/logo-white.webp'
import BannerImage from '../../assets/img/header-bg.webp'

import './styles.scss'

import { getAllExperiences } from '../../services/FirebaseServices/experienceServices'

import {
  makeSelectLocation,
  makeSelectStartDate,
  makeSelectEndDate,
  makeSelectTipoExperiencia,
  makeSelectSearchTipoExperiencia,
  clean_search,
  set_search_tipo_experiencia,
} from '../../redux/ducks/search'
import { getAgencyById } from '../../services/FirebaseServices/agencyServices'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const stateSelector = createSelector(
  [
    makeSelectLocation,
    makeSelectStartDate,
    makeSelectEndDate,
    makeSelectTipoExperiencia,
    makeSelectSearchTipoExperiencia,
  ],
  (location, startDate, endDate, tipoExperiencia, searchTipoExperiencia) => ({
    location,
    startDate,
    endDate,
    tipoExperiencia,
    searchTipoExperiencia,
  }),
)

const actionDispatch = (dispatch) => ({
  cleanSearch: () => dispatch(clean_search()),
  setSearchTipoExperiencia: (experiencia) =>
    dispatch(set_search_tipo_experiencia(experiencia)),
})

const Category = () => {
  const history = useHistory()
  const { category } = useParams()

  const { location, startDate, endDate, tipoExperiencia } =
    useSelector(stateSelector)

  const { cleanSearch, setSearchTipoExperiencia } = actionDispatch(
    useDispatch(),
  )

  const [experiencesData, setExperienceData] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setSearchTipoExperiencia(category)
    fetchData()
  }, [category, location, startDate, endDate])

  const fetchData = async () => {
    try {
      const experiencesResponse = await getAllExperiences(
        location,
        tipoExperiencia,
        startDate,
        endDate,
      )

      if (startDate === null || endDate === null) {
        const addAgencyToExp = await Promise.all(
          experiencesResponse.map(async (exp) => {
            const agencyResponse = await getAgencyById(exp.agencyKey)

            return { ...exp, agencyName: agencyResponse?.name }
          }),
        )
        setExperienceData(addAgencyToExp)
        setIsLoading(false)
      } else {
        const addAgencyToExp = await Promise.all(
          experiencesResponse.map(async (exp) => {
            const agencyResponse = await getAgencyById(exp.agencyKey)

            return { ...exp, agencyName: agencyResponse?.name }
          }),
        )

        const filteredData = filterByDate(addAgencyToExp)
        setExperienceData(filteredData)
        setIsLoading(false)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const title = () => {
    switch (category) {
      case 'HOTEL':
        return 'Hoteles, hostales y alojamientos'
      case 'AGENCY':
        return 'Experiencia turística, agroturismo y turismo aventura'
      case 'RESTAURANT':
        return 'Bar, restaurant y café'
      default:
        return 'Todas las experiencias'
    }
  }

  function filterByDate(data) {
    const noEndDate = data.filter((exp) => exp.dateEnd === null)

    const filter = data.filter(
      (exp) =>
        new Date(exp.dateInit) <= new Date(startDate) &&
        new Date(exp.dateEnd) >= new Date(endDate),
    )

    const finalExperiences = [...noEndDate, ...filter]

    return finalExperiences
  }

  return (
    <>
      <Box mb={5} className="banner-container">
        <LazyLoadImage
          src={WhiteLogo}
          alt="logo"
          className="logo-img"
          onClick={() => cleanSearch()}
          style={{ width: '10%', height: 'auto' }}
        />

        <Search className="search-component" />

        <LazyLoadImage
          src={BannerImage}
          alt="Banner"
          width="100%"
          loading="eager"
          height="100%"
        />
      </Box>
      <Box>
        <Container>
          <h2>{title()}</h2>
          {isLoading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          ) : experiencesData.length > 0 ? (
            <Grid container spacing={2}>
              {experiencesData.map((exp) => (
                <Grid item xs={12} sm={6} md={4} key={exp.key}>
                  <ExperienceCard experience={exp} />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box textAlign="center">
              <WarningRoundedIcon style={{ fontSize: 120, color: '#d5d5d5' }} />
              <h1 style={{ color: '#d5d5d5' }}>
                No existen resultados para esta búsqueda
              </h1>
            </Box>
          )}
        </Container>
      </Box>
      <Footer />
    </>
  )
}

export default Category
